module.exports = __webpack_public_path__ + "media/images/btn_accept_semen_approval-b8b8b1d61878889dba83adedd99549d7.gif";